module.exports = __webpack_public_path__ + "static/media/2.308f639b.png";